<template>
  <div class="border border-dark-gray m-b-4 rounded-lg overflow-hidden" v-if="getRows.length || getComment.additional_info.comment">
    <div class="vessel_owners__table">
      <div class="colspan-1-6 bg-blue-dark uppercase p-x-3 p-y-2 fz13 fw500 text-white">Owners expenses</div>
    </div>

    <div 
      class="vessel_owners__table-wrap bg-white overflow-hidden"
      v-for="(item, i) in getRows"
      :key="i"
    >
      <div class="vessel_owners__table" v-if="item.additional_info.is_row">
        <div class="border-t border-r p-x-3 p-y-2 text-dark fw500">#{{1+i}}</div>
        <div class="border-t colspan-2-4 border-r p-x-2 p-y-2 text-dark">{{item.additional_info.title ? item.additional_info.title : ''}}</div>
        <div class="border-t border-r p-x-2 p-y-2 text-dark text-align-right">{{item.debit | formatNumberTwoZeroEmpty}}</div>
        <div class="border-t p-x-2 p-y-2 text-align-right">{{item.credit | formatNumberTwoZeroEmpty}}</div>
      </div>

      <div class="vessel_owners__table"
        v-if="item.additional_info.is_commission && (item.additional_info.commision ||
          item.commision_debit ||
          item.commision_credit)"
      >
        <div class="border-t border-r p-x-3 p-y-2 text-dark fw500">Commision on OE</div>
        <div class="border-t colspan-2-4 border-r p-x-2 p-y-2 text-dark relative pr20">
          {{item.additional_info.commision | formatNumberTwoZeroEmpty}}
          <span class="absolute top-2 right-2 text-gray-text">%</span>
        </div>
        <div class="border-t border-r p-x-2 p-y-2 text-dark text-align-right">{{item.commision_debit | formatNumberTwoZeroEmpty}}</div>
        <div class="border-t p-x-2 p-y-2 text-align-right">{{item.commision_credit | formatNumberTwoZeroEmpty}}</div>
      </div>
    </div>
    <div
        class="vessel_owners__table bg-white overflow-hidden rounded-bl-lg rounded-br-lg"
        v-if="getComment.additional_info.comment"
    >
      <div class="border-t border-r p-x-3 p-y-2 text-dark fw500">Comment</div>
      <div class="border-t colspan-2-4 border-r p-x-2 p-y-2 text-dark">{{getComment.additional_info.comment}}</div>
      <div class="border-t border-r"></div>
      <div class="border-t"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    expensesData: Array
  },
  computed: {
    getComment() {
      return this.expensesData.filter(el => {
        return el.expense_type == 'owners_expense'
      })[0]
    },
    getRows() {
      return this.expensesData.filter(el => {
        return el.expense_type == 'owners_expense' && 
          !el.is_comment &&
          ((el.additional_info.is_row && (el.debit ||
          el.credit || el.additional_info.title)) ||
          (el.additional_info.is_commission && (el.additional_info.commision ||
          el.commision_debit ||
          el.commision_credit || el.additional_info.title)))
      })
    },
   /*  getComment() {
      let comment = this.expensesData.filter(el => {
        return el.expense_type == 'owners_expense' && el.is_comment
      })
      return comment.length ? comment[0] : null
    } */
  }
}
</script>

<style scoped>
.pr20 {
  padding-right: 20px;
}
</style>